export const REPORTS_BASE = '/reports';

// Route helpers for the Reports module. Add other report routes here as they are
// migrated off hardcoded strings so the route definition (App.tsx) and the nav
// item (Sidebar.tsx) stay in sync.
export const reportsPaths = {
  reviews: `${REPORTS_BASE}/reviews`,
  /**
   * Insights Bot knowledge-base console. Also deliberately outside /reports —
   * it maintains the bot's knowledge of the Reports module rather than being a
   * report, and it is gated by `enableInsightsBotKnowledgeBase` in
   * constants/InsightsBotKnowledgeBaseConstants.ts.
   */
  insightsBotKnowledgeBase: '/insightsbot/knowledgebase',
} as const;
